export default "__VITE_ASSET__41731658__"